import { render, staticRenderFns } from "./Welcome1.vue?vue&type=template&id=012226ab&scoped=true"
var script = {}
import style0 from "./Welcome1.vue?vue&type=style&index=0&id=012226ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012226ab",
  null
  
)

export default component.exports